// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-3sl-6kfo clearfix","list":"list-3CTzYokB","pd15":"pd15-371t_LPs clearfix","xs_word_02":"xs_word_02-lu4tiLZQ","qqg":"qqg-Qewg68E3"};